export const checkIsAvailablePurchase = (masterBook) => {
  if (masterBook.length == 0) return false;

  if (masterBook._max_purchase_count[0].limited_type == "none") return true;

  var totalGettableCount = 0;
  masterBook._max_purchase_count[0].gettable_counts.forEach((gettableCount) => {
    // is_limited: false の場合はcountが存在しないが、購入可能となるので適当に1を加算し、最終的にtrueを返すようにする
    if (!gettableCount.is_limited) {
      totalGettableCount += 1;
    } else {
      totalGettableCount += gettableCount.count;
    }
  });
  return totalGettableCount > 0;
};
